import { TableCell, TableRow } from '@mui/material';
import React from 'react';

type Props = {
  linhasVazias: number;
  tabelaVazia: boolean;
  alturaLinha: number;
};

const Filler: React.FC<Props> = (props) => {
  const { linhasVazias, tabelaVazia, alturaLinha } = props;

  if (linhasVazias <= 0 || tabelaVazia) {
    return null;
  }

  return (
    <TableRow style={{ height: alturaLinha * linhasVazias }}>
      <TableCell colSpan={5} />
    </TableRow>
  );
};

export default Filler;
